export default __webpack_public_path__ + "static/after-support-thumbnail-first-21e0826b85a44f5682d66d86d77142ae.png";